<template>
  <a-drawer
    :maskClosable="false"
    width="35%"
    :label-col="{ span: 4 }"
    :wrapper-col="{ span: 14 }"
    :visible="open"
    @close="onCloseConfirm(() => (open = false))"
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>

    <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />

    <a-form-model ref="form" :model="form" :rules="rules">
      <!-- 分类名称 -->
      <a-form-model-item label="分类名称" prop="categoryName">
        <a-input v-model="form.categoryName" placeholder="请输入" :maxLength="50" allowClear />
      </a-form-model-item>

      <!-- 状态 -->
      <a-form-model-item label="状态" prop="status">
        <a-radio-group button-style="solid" v-model="form.status">
          <a-radio-button :value="1">启用</a-radio-button>
          <a-radio-button :value="0">禁用</a-radio-button>
        </a-radio-group>
      </a-form-model-item>

      <!-- 图标 -->
      <a-form-model-item label="类目图标" prop="icon">
        <file-upload
          type="image"
          :defaultList="form.icon ? [form.icon] : []"
          :file="form.icon"
          :count="1"
          :isUpload="false"
          autoCropWidth="80"
          autoCropHeight="80"
          @input="getImg($event, 'icon')"
        />
      </a-form-model-item>

      <!-- 图片 -->
      <a-form-model-item label="类目图片" prop="pic">
        <file-upload
          type="image"
          :defaultList="form.pic ? [form.pic] : []"
          :file="form.pic"
          :count="1"
          :isUpload="false"
          autoCropWidth="80"
          autoCropHeight="80"
          @input="getImg($event, 'pic')"
        />
      </a-form-model-item>

      <!-- 说明内容 -->
      <a-form-model-item label="说明内容" prop="recommendVal">
        <a-input v-model="form.recommendVal" placeholder="请输入" :maxLength="20" allowClear />
      </a-form-model-item>

      <!-- 单位 -->
      <a-form-model-item label="单位" prop="unitVal">
        <a-input v-model="form.unitVal" placeholder="请输入" :maxLength="20" allowClear />
      </a-form-model-item>

      <!-- 备注 -->
      <a-form-model-item label="备注" prop="remark">
        <a-textarea v-model="form.remark" placeholder="请输入" :maxLength="150" :rows="3" allowClear />
      </a-form-model-item>
      <!-- 排序 -->
      <a-form-model-item label="排序" prop="sort">
        <a-input
          v-model="form.sort"
          placeholder="请输入"
          :maxLength="3"
          allowClear
          @input="form.sort = form.sort.replace(/\D/g, '').slice(0, 3)"
        />
      </a-form-model-item>
      <!-- 按钮 -->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel">取消</a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getObj, addObj, putObj } from '@/api/maintenance/service'

const defaultForm = {
  id: undefined,
  categoryName: undefined,
  pic: undefined,
  icon: undefined,
  remark: undefined,
  parentId: 0,
  status: 1,
  sort: 99,
  recommendVal: undefined,
  unitVal: undefined,
}

export default {
  name: 'CreateForm',
  props: {
    statusOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      submitLoading: false,
      open: false,
      showLoading: false,
      formTitle: '',
      form: { ...defaultForm },
      rules: {
        categoryName: [{ required: true, message: '请输入分类名称', trigger: 'blur' }],
        icon: [{ required: true, message: '请上传类目图标', trigger: 'blur' }],
        pic: [{ required: true, message: '请上传类目图片', trigger: 'blur' }],
        sort: [
          { required: true, message: '请输入排序', trigger: 'blur' },
          { pattern: /^[0-9]\d{0,2}$/, message: '0-999 整数', trigger: 'blur' },
        ],
        recommendVal: [{ required: true, message: '请输入说明内容', trigger: 'blur' }],
        unitVal: [{ required: true, message: '请输入单位', trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }],

      },
    }
  },
  methods: {
    /* -------- 对外暴露方法 -------- */
    handleAdd(parentRow, forceGrade) {
      this.reset()
      if (parentRow) {
        // 强制指定层级 > 推导层级
        const grade = forceGrade || (parentRow.grade || 1) + 1
        if (grade > 3) {
          this.$message.warning('最多支持三级维修服务分类')
          return
        }
        this.form.parentId = parentRow.id
        this.formTitle = grade === 2 ? '添加二级维修服务分类' : '添加三级维修服务分类'
      } else {
        this.form.parentId = 0
        this.formTitle = '添加一级维修服务分类'
      }
      this.open = true
    },

    handleUpdate(row) {
      this.reset()
      const id = row.id || row
      getObj(id).then((res) => {
        this.form = res.data
        this.formTitle = '修改维修服务分类'
        this.open = true
      })
    },

    /* -------- 内部方法 -------- */
    reset() {
      this.form = { ...defaultForm }
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },

    getImg(url, field) {
      this.form[field] = url
      this.$refs.form.clearValidate(field)
    },

    cancel() {
      this.onCloseConfirm(() => (this.open = false))
    },

    onCloseConfirm(done) {
      this.$confirm({
        title: '是否确认关闭并清空数据？',
        onOk: () => {
          this.reset()
          done()
        },
      })
    },

    submitForm() {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        this.submitLoading = true
        this.showLoading = true
        this.$nextTick(() => this.$refs.LoadingPop.init(1))

        const api = this.form.id ? putObj : addObj
        api(this.form)
          .then(() => {
            this.$message.success(this.form.id ? '修改成功' : '新增成功')
            this.open = false
            this.$emit('ok')
          })
          .finally(() => {
            this.submitLoading = false
            this.showLoading = false
          })
      })
    },
  },
}
</script>
